import Axios from 'axios';

const host = process.env.VUE_APP_URL_API;

export default async (id, data) => {
  return Axios.post(`${host}/checkout/subscription-payment/${id}`, data);
};
